import script from "./Preview_code.vue?vue&type=script&setup=true&lang=js"
export * from "./Preview_code.vue?vue&type=script&setup=true&lang=js"

import "./Preview_code.vue?vue&type=style&index=0&id=3d9f8b36&lang=scss&scoped=true"
import "./Preview_code.vue?vue&type=style&index=1&id=3d9f8b36&lang=scss"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d9f8b36"]])

export default __exports__